// extracted by mini-css-extract-plugin
module.exports = {"tabs":"typeTabs_tabs__UWVW3","item":"typeTabs_item__cGIkY","name":"typeTabs_name__FYMdQ","tag":"typeTabs_tag__VZNzA","active":"typeTabs_active__DE1fb"};